import React, { useState, useEffect } from "react";
import ShareTable from "../../../shares/tables/ShareTable";
import Search from "../../../shares/search/Search";
import { Modal, Chip, CircularProgress } from "@mui/material";
import AddGroups from "./modals/AddVideos";
import useFetch from "../../../../hooks/useFetch";
import moment from "jalali-moment";
import {
  DeleteOutline,
  EditOutlined,
  OndemandVideoOutlined,
  AddRounded,
} from "@mui/icons-material";
import { useSearchParams } from "react-router-dom";
import {
  PageHeader,
  StatusBadge,
  TableAction,
} from "../../../shares/dashboard/DashboardWidgets";

const Videos = () => {
  const [newModal, setNewModal] = useState(false);
  const [edit, setEdit] = useState(null);
  const [classrooms, setClassrooms] = useState();
  const [searchParams, setSearchParams] = useSearchParams();
  const [id, setId] = useState();

  const handleClose = () => {
    setNewModal(false);
    setEdit(null);
  };

  const getClassrooms = useFetch({
    method: "GET",
    url: "management/classrooms/",
    params: { page: searchParams.get("page") || 1, search: searchParams.get("search") || "" },
    safeRead: true,
    noHeader: false,
    trigger: true,
    setter: setClassrooms,
  });

  const deleteClassrooms = useFetch({
    method: "DELETE",
    url: `management/classrooms/${id}/`,
    noHeader: false,
    trigger: false,
    caller: getClassrooms,
    argFunc: () => {
      if (classrooms?.results.length === 1) {
        setSearchParams((prev) => {
          const next = new URLSearchParams(prev);
          next.set("page", Math.max(1, Number(searchParams.get("page") || 1) - 1));
          return next;
        });
      }
      setId(null);
    },
  });

  const handleEdit = (id) => {
    setNewModal(true);
    setEdit(id);
  };

  const columns = [
    { id: "ClassroomName", label: "نام" },
    { id: "classroom_headline", label: "مبحث" },
    {
      id: "classroom_available_time_end",
      label: "پایان",
      render: (row) =>
        moment(row.classroom_available_time_end, "YYYY/MM/DD")
          .locale("fa")
          .format("YYYY/MM/DD"),
    },
    {
      id: "classroom_finished",
      label: "وضعیت",
      render: (row) => (
        <StatusBadge
          label={row.classroom_finished ? "پایان یافته" : "در حال برگزاری"}
          tone={row.classroom_finished ? "neutral" : "success"}
        />
      ),
    },
    {
      id: "classroom_groups",
      label: "گروه",
      render: (row) => (
        <div className="flex flex-wrap justify-center gap-2xs">
          {row.classroom_groups.map((group) => (
            <span
              key={group.id}
              className="rounded-pill bg-surface-sunken px-md py-2xs text-xs text-ink-muted"
            >
              {group.name}
            </span>
          ))}
        </div>
      ),
    },
    {
      id: "edit",
      label: "ویرایش",
      render: (row) => (
        <TableAction
          icon={EditOutlined}
          onClick={() => handleEdit(row.classroom_id)}
          label="ویرایش درس"
        />
      ),
    },
    {
      id: "delete",
      label: "حذف",
      render: (row) =>
        deleteClassrooms.loading && id === row.classroom_id ? (
          <CircularProgress size="2rem" color="inherit" className="text-danger" />
        ) : (
          <TableAction
            icon={DeleteOutline}
            onClick={() => setId(row.classroom_id)}
            label="حذف درس"
            tone="danger"
          />
        ),
    },
  ];

  useEffect(() => {
    id && deleteClassrooms.reFetch();
  }, [id]);

  return (
    <div className="flex flex-col gap-xl pb-4xl">
      <PageHeader
        title="درس‌ها و ویدیوها"
        description="مدیریت جلسات ضبط‌شده و تخصیص آن‌ها به گروه‌ها"
        icon={OndemandVideoOutlined}
        actionLabel="افزودن درس"
        actionIcon={AddRounded}
        onAction={() => setNewModal(true)}
      />

      <div className="flex flex-col gap-lg">
        <Search getFiltered={getClassrooms} />

        <ShareTable
          data={classrooms?.results ?? []}
          columns={columns}
          getPage={getClassrooms}
          totalCount={classrooms?.count}
          page={Number(searchParams.get("page")) || 1}
          setPage={setSearchParams}
        />
      </div>

      <Modal
        open={newModal}
        onClose={handleClose}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <AddGroups close={handleClose} get={getClassrooms} edit={edit} />
      </Modal>
    </div>
  );
};

export default Videos;
